import { useEffect, useState } from "react";
import {
    FolderPlus,
    Folder,
    FileText,
    Lock,
    Globe,
    X
} from "lucide-react";

export default function MediaListForm({

    initialValues = {},
    loading = false,
    submitLabel = "Create List",

    onSubmit,
    onCancel

}) {

    const [values, setValues] = useState({

        name: "",
        description: "",
        visibility: "private"

    });

    useEffect(() => {

        setValues({

            name: initialValues.name || "",
            description: initialValues.description || "",
            visibility: initialValues.visibility || "private"

        });

    }, [initialValues]);

    function handleChange(e) {

        const { name, value } = e.target;

        setValues(previous => ({

            ...previous,
            [name]: value

        }));

    }

    function handleSubmit(e) {

        e.preventDefault();

        if (!values.name.trim()) return;

        onSubmit?.(values);

    }

    return (

        <div className="media-list-overlay">

            <form

                className="media-list-dialog"

                onSubmit={handleSubmit}

            >

                <div className="media-list-header">

                    <div className="media-list-title">

                        <FolderPlus size={24} />

                        <div>

                            <h2>

                                {
                                    initialValues.id
                                        ? "Edit Media List"
                                        : "Create Media List"
                                }

                            </h2>

                            <p>

                                Organize files into reusable collections.

                            </p>

                        </div>

                    </div>

                    <button

                        type="button"

                        className="dialog-close"

                        onClick={onCancel}

                    >

                        <X size={18} />

                    </button>

                </div>

                <div className="media-list-body">

                    <div className="form-group">

                        <label>

                            List Name

                        </label>

                        <div className="input-wrapper">

                            <Folder size={18} />

                            <input

                                name="name"

                                value={values.name}

                                onChange={handleChange}

                                placeholder="Marketing Assets"

                                autoFocus

                            />

                        </div>

                    </div>

                    <div className="form-group">

                        <label>

                            Description

                        </label>

                        <div className="input-wrapper textarea">

                            <FileText size={18} />

                            <textarea

                                rows={4}

                                name="description"

                                value={values.description}

                                onChange={handleChange}

                                placeholder="Optional description"

                            />

                        </div>

                    </div>

                    <div className="form-group">

                        <label>

                            Visibility

                        </label>

                        <div className="input-wrapper">

                            {

                                values.visibility === "private"

                                    ? <Lock size={18} />

                                    : <Globe size={18} />

                            }

                            <select

                                name="visibility"

                                value={values.visibility}

                                onChange={handleChange}

                            >

                                <option value="private">

                                    Private

                                </option>

                                <option value="public">

                                    Public

                                </option>

                            </select>

                        </div>

                    </div>

                </div>

                <div className="media-list-footer">

                    <button

                        type="button"

                        className="btn"

                        onClick={onCancel}

                    >

                        Cancel

                    </button>

                    <button

                        type="submit"

                        className="btn btn-primary"

                        disabled={loading}

                    >

                        {

                            loading

                                ? "Saving..."

                                : submitLabel

                        }

                    </button>

                </div>

            </form>

            <style>{`

.media-list-overlay{

    position:fixed;
    inset:0;

    display:flex;
    align-items:center;
    justify-content:center;

    background:rgba(15,23,42,.45);

    backdrop-filter:blur(4px);

    z-index:9999;

}

.media-list-dialog{

    width:min(560px,95vw);

    background:#FFF;

    border-radius:20px;

    overflow:hidden;

    box-shadow:
        0 25px 70px rgba(15,23,42,.22);

    animation:dialogIn .18s ease;

}

@keyframes dialogIn{

    from{

        opacity:0;
        transform:translateY(10px) scale(.98);

    }

    to{

        opacity:1;
        transform:none;

    }

}

.media-list-header{

    padding:24px;

    display:flex;

    justify-content:space-between;

    align-items:flex-start;

    border-bottom:1px solid #EEF2F7;

}

.media-list-title{

    display:flex;

    gap:14px;

    align-items:flex-start;

}

.media-list-title svg{

    color:#2563EB;

}

.media-list-title h2{

    margin:0;

    font-size:22px;

}

.media-list-title p{

    margin-top:6px;

    color:#64748B;

    font-size:14px;

}

.dialog-close{

    width:38px;
    height:38px;

    border:none;

    border-radius:10px;

    background:#F8FAFC;

    cursor:pointer;

}

.dialog-close:hover{

    background:#E2E8F0;

}

.media-list-body{

    padding:24px;

    display:flex;

    flex-direction:column;

    gap:20px;

}

.form-group{

    display:flex;

    flex-direction:column;

    gap:8px;

}

.form-group label{

    font-weight:600;

    font-size:14px;

}

.input-wrapper{

    display:flex;

    align-items:center;

    gap:12px;

    border:1px solid #E2E8F0;

    border-radius:12px;

    padding:0 14px;

    transition:.2s;

}

.input-wrapper:focus-within{

    border-color:#2563EB;

    box-shadow:0 0 0 4px rgba(37,99,235,.08);

}

.input-wrapper svg{

    color:#64748B;

}

.input-wrapper input,
.input-wrapper textarea,
.input-wrapper select{

    flex:1;

    border:none;

    outline:none;

    background:none;

    padding:14px 0;

    font-size:14px;

}

.input-wrapper textarea{

    resize:vertical;

    min-height:90px;

}

.media-list-footer{

    display:flex;

    justify-content:flex-end;

    gap:12px;

    padding:20px 24px;

    border-top:1px solid #EEF2F7;

    background:#FFF;

}

`}</style>

        </div>

    );

}